import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardList from "components/Card/CardList.jsx";
//import LeadHeader from "containers/Headers/LeadHeader.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import ReviewsModal from "views/Components/ReviewsModal.jsx";
import EmailModal from "views/Components/EmailModal.jsx";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

class CampaignLeads extends React.Component {
  state = {
    value: 0,
    noticeModal: false,
    reviews: [],
    lead: {},
    emailModal: false
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };
  showReview = (lead, reviews) => {
    this.setState(
      {
        reviews: reviews,
        lead: lead
      },
      () => {
        this.openModal();
      }
    );
  };
  sendEmail = lead => {
    this.setState(
      {
        lead: lead
      },
      () => {
        this.setState({ emailModal: true });
      }
    );
  };
  handleModalClose = () => {
    this.setState({ noticeModal: false, reviews: [], lead: {} });
  };
  handleEmailModalClose = () => {
    this.setState({
      emailModal: false
    });
  };
  openModal() {
    this.setState({ noticeModal: true });
  }
  render() {
    return (
      <div>
        {this.state.emailModal ? (
          <EmailModal
            emailModal={this.state.emailModal}
            handleClose={this.handleEmailModalClose}
            lead={this.state.lead}
          />
        ) : null}
        <ReviewsModal
          noticeModal={this.state.noticeModal}
          handleClose={this.handleModalClose}
          reviews={this.state.reviews}
          lead={this.state.lead}
        />

        <GridContainer>
          {/* <GridItem xs={12} sm={12} md={12} lg={12}>
            <LeadHeader />
          </GridItem> */}
          {this.props.fetching ? (
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <CustomLinearProgress
                variant="indeterminate"
                color="primary"
                value={30}
              />
            </GridItem>
          ) : null}

          {this.props.leads.map((lead, index) => {
            return (
              <GridItem xs={12} sm={12} md={12} lg={12} key={index}>
                <CardList
                  lead={lead}
                  showReview={this.showReview}
                  sendEmail={this.sendEmail}
                />
              </GridItem>
            );
          })}
        </GridContainer>
      </div>
    );
  }
}

CampaignLeads.propTypes = {
  classes: PropTypes.object.isRequired,
  fetching: PropTypes.bool,
  leads: PropTypes.array,
  addLeads: PropTypes.func
};

const mapStateToProps = (state, props) => {
  var id = props.match.params.id;
  var campaignLeads = state.leads.filter(lead => lead.campaignId === id);
  return {
    leads: campaignLeads,
    campaigns: state.campaigns
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCampaign(name) {
      //dispatch(addCampaign(name));
    },
    removeCampaign(id) {
      //dispatch(removeCampaign(id));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(dashboardStyle)(CampaignLeads));



// WEBPACK FOOTER //
// ./src/views/Dashboard/CampaignLeads.jsx